import React from 'react';
import { ToolTipElement } from '../../..';
import { SelectInputTemplateProps, SelectInputOption } from '../interfaces';
import { SelectInputStyles } from '../styles';

export const SelectInputDefaultTemplate = (props: SelectInputTemplateProps) => {
  const getOptions = () => {
    const options = props.options.map(
      (option: SelectInputOption, index: number) => {
        return (
          <option key={index} value={option.value} disabled={option.isDisabled}>
            {option.text}
          </option>
        );
      }
    );

    return options;
  };

  return (
    <SelectInputStyles data-cy="select-input-element" className={props.classes}>
      <label htmlFor={props.id}>
        <select
          id={props.id}
          name={props.name}
          value={props.value}
          disabled={props.disabled}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          data-clean={props['data-clean']}
          data-blurred={props['data-blurred']}
          data-valid={props['data-valid']}
        >
          {getOptions()}
        </select>
        {props.tips && props.tips.length ? (
          <ToolTipElement styleClasses={['toolTipBase']} tips={props.tips} />
        ) : (
          ''
        )}
      </label>
    </SelectInputStyles>
  );
};
